import type { AutomationPageProps, PageProps } from "@/types";
import React, { FC } from "react";
import {
  AutomationChallenges,
  AutomationClickForKycc,
  AutomationDigitalBoarding,
  AutomationGlobalConsentManagement,
  AutomationHero,
  AutomationPerpetualKyc,
  AutomationPrecisionKyt,
} from "../automation";
import { NextPage } from "../next-page";

export const Automation: FC<PageProps<AutomationPageProps>> = (props) => {
  return (
    <div>
      <AutomationHero
        label={props.meta.translation.solutions.hero.label}
        title={props.data.title}
        description={props.data.description}
        cover={props.data.cover}
        cta={props.data.cta}
      />
      {/* <AutomationChallenges
        content={props.data.challengesContent}
        cta={props.data.challengesCta}
      /> */}
      <AutomationDigitalBoarding
        subtitle={props.data.digitalBoardingSubtitle}
        content={props.data.digitalBoardingContent}
        networkOfSpecialists={props.data.networkOfSpecialists}
        cover={props.data.digitalBoardingCover}
      />
      <AutomationGlobalConsentManagement
        content={props.data.globalConsentManagementContent}
        cover={props.data.globalConsentManagementCover}
      />
      <AutomationPrecisionKyt
        content={props.data.precisionKytContent}
        cta={props.data.precisionKytCta}
        cover={props.data.precisionKytCover}
      />
      <AutomationClickForKycc
        content={props.data.clickForKyccContent}
        cta={props.data.clickForKyccCta}
        cover={props.data.clickForKyccCover}
      />
      <AutomationPerpetualKyc
        content={props.data.perpetualKycContent}
        cards={props.data.perpetualKycCards}
        cta={props.data.perpetualKycCta}
      />
      <NextPage {...props.data.nextPage} />
    </div>
  );
};
